export default __webpack_public_path__ + "static/media/logo.988c15f8.svg";